import React from 'react'
import { Slide } from '@mui/material'

function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
}

export default React.forwardRef(Transition)
